import { notify } from '@affine/component';
import { useAsyncCallback } from '@affine/core/components/hooks/affine-async-hooks';
import { FetchService } from '@affine/core/modules/cloud';
import { useI18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
import { useState } from 'react';

export const useDataExport = () => {
  const t = useI18n();
  const fetchService = useService(FetchService);
  const [isExporting, setIsExporting] = useState(false);

  const exportData = useAsyncCallback(async () => {
    if (isExporting) return;

    setIsExporting(true);
    try {
      const response = await fetchService.fetch('/api/auth/export-data');
      if (!response.ok) {
        throw new Error(`Export failed: ${response.status}`);
      }

      const data = await response.json();
      const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json',
      });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `streamlain-data-export-${new Date().toISOString().slice(0, 10)}.json`;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);

      notify.success({
        title: t['com.streamlain.settings.data-export.success'](),
      });
    } catch (error) {
      console.error('Data export failed:', error);
      notify.error({
        title: t['com.streamlain.settings.data-export.error'](),
      });
    } finally {
      setIsExporting(false);
    }
  }, [fetchService, isExporting, t]);

  return { exportData, isExporting };
};
